/** The strings for this feature, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const incidentsStrings = pickLocale(ar.incidentsStrings, en.incidentsStrings)
export const validationStrings = pickLocale(ar.validationStrings, en.validationStrings)
